import React from 'react';
import PropTypes from 'prop-types';
import { Button, Modal } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEye } from '@fortawesome/pro-regular-svg-icons';
import { useDispatch, useSelector } from 'react-redux';
import {
  fetchSingleDevice,
  selectSingleDevice,
  toggleChannelGroupVisibility,
} from '../../../../redux/slices/singleDeviceSlice/singleDeviceSlice';

const HiddenSensorsModal = ({
  show,
  handleClose,
  hiddenChannelGroups,
}) => {
  const dispatch = useDispatch();
  const device = useSelector(selectSingleDevice);

  const findSensorLabel = (channelKey) => {
    const sensorGroup = device.sensors
      .flatMap((s) => s.channelGroups)
      .find((g) => g.channelKey === channelKey);
    return sensorGroup.label || channelKey;
  };
  const handleUnhide = async (channelKey) => {
    await dispatch(toggleChannelGroupVisibility({
      channelKey,
      label: findSensorLabel(channelKey),
      isHidden: false,
    })).unwrap();
    await dispatch(fetchSingleDevice()).unwrap();
    handleClose();
  };

  return (
    <Modal show={show} onHide={handleClose}>
      <Modal.Header closeButton>
        <Modal.Title>Hidden Sensors</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {hiddenChannelGroups.map((channelKey) => (
          <div key={channelKey} className="d-flex justify-content-between align-items-center mb-2">
            <span>{findSensorLabel(channelKey)}</span>
            <Button
              variant="link"
              onClick={() => handleUnhide(channelKey)}
              className="text-primary"
            >
              <FontAwesomeIcon icon={faEye} className="mr-1" />
              Show
            </Button>
          </div>
        ))}
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={handleClose}>
          Close
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

HiddenSensorsModal.propTypes = {
  show: PropTypes.bool.isRequired,
  handleClose: PropTypes.func.isRequired,
  hiddenChannelGroups: PropTypes.arrayOf(PropTypes.string).isRequired,
};

export default HiddenSensorsModal;
